export default {"src":"/_next/static/media/trashcan.b25ee4cc.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};